module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-114x114-66813ae6874701088ac10cb8b1d97d77.png";